module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/b18a7b9e8a4105b3d91df3621ab34b3d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_tick.svg
// module id = Z1mS
// module chunks = 0